import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
  Chip,
  CircularProgress,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import axios from "axios";
import { BACKEND_BASE_URL } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export default function AddDataForm({ open, onClose, onSubmit, api }) {
  const [formData, setFormData] = useState({
    country: "",
    state: "",
    county: "",
    municipality_name: "",
    channel_url: "",
    website_url: "",
    channel_id: "",
    playlists: [],
  });
  const [countryOptions, setCountryOptions] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [countyOptions, setCountyOptions] = useState([]);
  // const [municipalityOptions, setMunicipalityOptions] = useState([]);
  const [muncipalityOptions, setMuncipalityOptions] = useState([]);
  // const [countyOptions, setCountyOptions] = useState([]);
  const [loadingMuncipality, setLoadingMuncipality] = useState(false);
  const [bodPlaylistOptions, setBodPlaylistOptions] = useState([]);
  const [townPlaylistOptions, setTownPlaylistOptions] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCounties, setLoadingCounties] = useState(false);
  // const [loadingMunicipalities, setLoadingMuncipality] = useState(false);
  const [loadingBodPlaylists, setLoadingBodPlaylists] = useState(false);
  const [loadingTownPlaylists, setLoadingTownPlaylists] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);


  const [additionalFields, setAdditionalFields] = useState({
    bod: {
      channel_url: "",
      channel_id: "",
      playlists: [],
      selected: false,
      notes: "", // Board of Education Notes
      website_url: ""
    },
    townCouncil: {
      channel_url: "",
      channel_id: "",
      playlists: [],
      selected: false,
      notes: "", // Board of Education Notes
      website_url: ""
    },
  });


  useEffect(() => {
    if (open) {
      fetchCountries();
      if (formData.channel_id) {
        fetchBodPlaylists(formData.channel_id, setBodPlaylistOptions);
        fetchTownPlaylists(formData.channel_id, setTownPlaylistOptions);
      }
    }
  }, [open]);

  useEffect(() => {
    if (formData.country) {
      fetchStates();
    } else {
      setStateOptions([]);
      setFormData((prev) => ({
        ...prev,
        state: "",
        county: "",
        municipality_name: ""
      }));
    }
  }, [formData.country]);




  useEffect(() => {
    if (formData.state) {
      fetchCounties();
    }
  }, [formData.state]);

  useEffect(() => {
    if (formData.state && formData.county) {
      fetchMunicipalities();
    }
  }, [formData.state, formData.county]);

  const fetchCountries = async () => {
    setLoadingCountries(true);
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/countries/`);
      if (Array.isArray(response.data)) {
        setCountryOptions(response.data); // store full objects
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoadingCountries(false);
    }
  };


  const fetchStates = async () => {
    if (!formData.country) return;
    setLoadingStates(true);
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/states/`, {
        params: { country_id: formData.country } // sending country ID
      });
      if (response.data && response.data.states) {
        setStateOptions(response.data.states);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setLoadingStates(false);
    }
  };

  useEffect(() => {
  if (stateOptions.length === 1) {
    setFormData((prev) => ({
      ...prev,
      state: stateOptions[0],
    }));
  }
}, [stateOptions]);
  const fetchCounties = async () => {
    setLoadingCounties(true);
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, {
        params: { state: formData.state },
      });
      if (response.data && response.data.counties) {
        setCountyOptions(response.data.counties);
      }
    } catch (error) {
      console.error("Error fetching counties:", error);
    } finally {
      setLoadingCounties(false);
    }
  };

  const fetchMunicipalities = async () => {
    setLoadingMuncipality(true);
    try {
      const response = await axios.get(
        `${BACKEND_BASE_URL}/api/municipalities/filter/`,
        {
          params: {
            state: formData.state,
            county: formData.county,
          },
        }
      );
      if (response.data && response.data.municipalities) {
        setMuncipalityOptions(response.data.municipalities);
      } else {
        setMuncipalityOptions([]);
      }
    } catch (error) {
      console.error("Error fetching municipalities:", error);
      setMuncipalityOptions([]);
    } finally {
      setLoadingMuncipality(false);
    }
  };

  // Fetch BOD Playlists
  const fetchBodPlaylists = async (channelId, setBodOptions) => {
    if (!channelId) return;
    setLoadingBodPlaylists(true);
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/fetch-playlists/`, {
        params: {
          channel_id: channelId,
          api_key: api
        },
      });
      if (response.data && response.data.playlists) {

        setBodOptions(response.data.playlists);
      }
    } catch (error) {
      console.error("Error fetching BOD playlists:", error);

      let errorMessage =
        error.response?.data?.error || "Error fetching BOE playlists";

      // Custom message for YouTube quota exceeded
      if (error.response?.status === 400) {
        errorMessage = error.response?.data?.error;
      }
      // Custom message for YouTube quota exceeded
      else if (error.response?.status === 429) {
        errorMessage = error.response?.data?.error;
      }
      else if (error.response?.status === 401) {
        errorMessage = error.response?.data?.error;
      }
      else if (error.response?.status === 403) {
        errorMessage = error.response?.data?.message;
      }
      else if (error.response?.status === 500) {
        errorMessage = error.response?.data?.message;
      }
      toast.error(`${errorMessage}`);
    } finally {
      setLoadingBodPlaylists(false);
    }
  };

  // Fetch Town Council Playlists
  const fetchTownPlaylists = async (channelId, setTownOptions) => {
    if (!channelId) return;
    setLoadingTownPlaylists(true);
    try {
      const response = await axios.get(`${BACKEND_BASE_URL}/api/fetch-playlists/`, {
        params: { channel_id: channelId, api_key: api },
      });
      if (response.data && response.data.playlists) {
        setTownOptions(response.data.playlists);
      }
    } catch (error) {
      console.error("Error fetching Town Council playlists:", error);

      let errorMessage =
        error.response?.data?.error || "Error fetching Town Council playlists";

      // Custom message for YouTube quota exceeded
      if (error.response?.status === 400) {
        errorMessage = error.response?.data?.error;
      }
      // Custom message for YouTube quota exceeded
      else if (error.response?.status === 429) {
        errorMessage = error.response?.data?.error;
      }
      else if (error.response?.status === 401) {
        errorMessage = error.response?.data?.error;
      }
      else if (error.response?.status === 403) {
        errorMessage = error.response?.data?.message;
      }
      else if (error.response?.status === 500) {
        errorMessage = error.response?.data?.message;
      }
      toast.error(`${errorMessage}`);
    } finally {
      setLoadingTownPlaylists(false);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBodChannelUrlBlur = async (channel_url) => {
    if (channel_url) {
      try {
        const response = await axios.get(
          `${BACKEND_BASE_URL}/api/fetch-channel-id/`,
          { params: { url: channel_url } }
        );
        if (response.data.channel_id) {
          setAdditionalFields((prevData) => ({
            ...prevData,
            bod: {
              ...prevData.bod,
              channel_id: response.data.channel_id,
            },
          }));
          fetchBodPlaylists(response.data.channel_id, setBodPlaylistOptions);
        }
      } catch (error) {
        console.error("Error fetching BOD channel ID", error);
        setAdditionalFields((prevData) => ({
          ...prevData,
          bod: {
            ...prevData.bod,
            channel_id: "",
          },
        }));
      }
    }
  };

  // Handle Town Council Channel URL Blur
  const handleTownChannelUrlBlur = async (channel_url) => {
    if (channel_url) {
      try {
        const response = await axios.get(
          `${BACKEND_BASE_URL}/api/fetch-channel-id/`,
          { params: { url: channel_url } }
        );
        if (response.data.channel_id) {
          setAdditionalFields((prevData) => ({
            ...prevData,
            townCouncil: {
              ...prevData.townCouncil,
              channel_id: response.data.channel_id,
            },
          }));
          fetchTownPlaylists(response.data.channel_id, setTownPlaylistOptions);
        }
      } catch (error) {
        console.error("Error fetching Town Council channel ID", error);
        setAdditionalFields((prevData) => ({
          ...prevData,
          townCouncil: {
            ...prevData.townCouncil,
            channel_id: "",
          },
        }));
      }
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setAdditionalFields((prevFields) => ({
      ...prevFields,
      [name]: { ...prevFields[name], selected: checked },
    }));
  };

  const handleDynamicFieldChange = (name, field, value) => {
    setAdditionalFields((prevFields) => ({
      ...prevFields,
      [name]: { ...prevFields[name], [field]: value },
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const dataToSend = {
      ...formData,
      additional: Object.keys(additionalFields).reduce((acc, key) => {
        if (additionalFields[key].selected) {
          acc[key] = {
            channel_url: additionalFields[key].channel_url,
            channel_id: additionalFields[key].channel_id,
            playlists: additionalFields[key].playlists.map((id) => {
              if (id === "whole-channel") {
                return {
                  name: "Whole Channel",
                  playlist_id: "whole-channel",
                  playlist_url: additionalFields[key].channel_url,
                };
              }
              if (id === "live-channel") {
                return {
                  name: "Live Channel",
                  playlist_id: "live-channel",
                  playlist_url: additionalFields[key].channel_url,
                };
              }
              const playlist = key === "bod"
                ? bodPlaylistOptions.find((p) => p.id === id)
                : townPlaylistOptions.find((p) => p.id === id);

              return {
                name: playlist?.title || "Unknown Playlist",
                playlist_id: playlist?.id || id,
                playlist_url: playlist?.url || "",
              };
            }),
            notes: additionalFields[key].notes,
            website_url: additionalFields[key].website_url
          };
        }
        return acc;
      }, {}),
    };

    try {
      const response = await axios.post(`${BACKEND_BASE_URL}/api/add-url/`, {
        ...dataToSend,
        api_key: api,
      });
      onSubmit(response.data);
      onClose();
      setFormData({
        country: "",
        state: "",
        county: "",
        municipality_name: "",
        channel_url: "",
        website_url: "",
        playlists: [],
      });
    } catch (error) {
      console.error("Error adding data:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Data</DialogTitle>
      <DialogContent style={{ maxHeight: '500px', overflowY: 'auto' }}>

        {/* Country Dropdown */}
        <FormControl fullWidth margin="dense">
          <InputLabel>Country</InputLabel>
          <Select
            name="country"
            value={formData.country}
            onChange={handleChange}
            fullWidth
          >
            {loadingCountries ? (
              <MenuItem disabled>
                <CircularProgress size={24} />
                Loading Countries...
              </MenuItem>
            ) : (
              countryOptions.map((country) => (
                <MenuItem key={country.id} value={country.id}>
                  {country.name}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>


        {/* State Dropdown */}
        <FormControl fullWidth margin="dense">
          <InputLabel>State</InputLabel>
          <Select
            name="state"
            value={formData.state}
            onChange={handleChange}
            fullWidth
          >
            {loadingStates ? (
              <MenuItem disabled>
                <CircularProgress size={24} />
                Loading States...
              </MenuItem>
            ) : (
              stateOptions.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>

        {/* County Dropdown */}
        <FormControl fullWidth margin="dense" disabled={!formData.state}>
          <InputLabel>County</InputLabel>
          <Select
            name="county"
            value={formData.county}
            onChange={handleChange}
            fullWidth
          >
            {loadingCounties ? (
              <MenuItem disabled>
                <CircularProgress size={24} />
                Loading Counties...
              </MenuItem>
            ) : (
              countyOptions.map((county) => (
                <MenuItem key={county} value={county}>
                  {county}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
        {/* Name Dropdown */}
        <FormControl fullWidth margin="dense" disabled={!formData.state}>
          <InputLabel>Town</InputLabel>
          <Select
            name="municipality_name"
            value={formData.municipality_name}
            onChange={handleChange}
            fullWidth
          >
            {loadingMuncipality ? (
              <MenuItem disabled>
                <CircularProgress size={24} />
                Loading Towns...
              </MenuItem>
            ) : muncipalityOptions.length === 0 ? (
              <MenuItem disabled>No Town available</MenuItem>
            ) : (
              muncipalityOptions.map((municipality) => (
                <MenuItem key={municipality} value={municipality}>
                  {municipality}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>


        {/* Checkbox for BOD and Town Council */}
        <InputLabel style={{ marginTop: "20px" }}>Channel Type</InputLabel>
        <FormControl component="fieldset" margin="dense">

          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={additionalFields.bod.selected}
                  onChange={handleCheckboxChange}
                  name="bod"
                />
              }
              label="Board Of Education"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={additionalFields.townCouncil.selected}
                  onChange={handleCheckboxChange}
                  name="townCouncil"
                />
              }
              label="Town Government"
            />
          </FormGroup>
        </FormControl>

        {/* Dynamic fields for BOD */}
        {additionalFields.bod.selected && (
          <>
            <TextField
              margin="dense"
              label="Board of Education Channel URL"
              fullWidth
              value={additionalFields.bod.channel_url}
              onBlur={() => { handleBodChannelUrlBlur(additionalFields.bod.channel_url) }}
              onChange={(e) => handleDynamicFieldChange('bod', 'channel_url', e.target.value)}
            />
            {/* Playlists for BOD */}
            <FormControl fullWidth margin="dense">
              <InputLabel>Board Of Education Playlists</InputLabel>
              <Select
                multiple
                value={additionalFields.bod.playlists}
                onChange={(e) => handleDynamicFieldChange('bod', 'playlists', e.target.value)}
                fullWidth
                renderValue={(selected) =>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>

                    {selected.map((id, index) => {
                      const playlist = bodPlaylistOptions.find((p) => p.id === id) || {};

                      return <Chip key={index} label={id === "whole-channel" ? "Main Channel" : id === "live-channel" ? "Live Channel" : playlist.title} style={{
                        margin: "2px",
                        backgroundColor: "#152F8F",
                        color: "white",
                      }} />;
                    })}
                  </div>
                }
              >

                {/* Add static "Whole Channel" option */}
                <MenuItem value="whole-channel">
                  <Checkbox checked={additionalFields.bod.playlists.includes('whole-channel')} />
                  <ListItemText primary="Main Channel" />
                </MenuItem>

                <MenuItem value="live-channel">
                  <Checkbox checked={additionalFields.bod.playlists.includes('live-channel')} />
                  <ListItemText primary="Live Channel" />
                </MenuItem>
                {loadingBodPlaylists ? (
                  <MenuItem disabled>
                    <CircularProgress size={24} />
                    Loading Board of Education Playlists...
                  </MenuItem>
                ) : bodPlaylistOptions.map((playlist) => (
                  <MenuItem key={playlist.id} value={playlist.id}>
                    <Checkbox checked={additionalFields.bod.playlists.includes(playlist.id)} />
                    <ListItemText primary={playlist.title} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>


            <TextField
              margin="dense"
              label="Board of Education Website URL"
              fullWidth


              value={additionalFields.bod.website_url}
              onChange={(e) =>
                handleDynamicFieldChange("bod", "website_url", e.target.value)
              }
            />

            <TextField
              margin="dense"
              label="Board of Education Notes"
              fullWidth
              multiline
              rows={3}
              value={additionalFields.bod.notes}
              onChange={(e) =>
                handleDynamicFieldChange("bod", "notes", e.target.value)
              }
            />


          </>
        )}



        {/* Dynamic fields for Town Council */}
        {additionalFields.townCouncil.selected && (
          <>
            <TextField
              margin="dense"
              label="Town Government Channel URL"
              fullWidth
              value={additionalFields.townCouncil.channel_url}

              onChange={(e) => handleDynamicFieldChange('townCouncil', 'channel_url', e.target.value)}
              onBlur={() => { handleTownChannelUrlBlur(additionalFields.townCouncil.channel_url) }}
            />

            {/* Playlists for Town Council */}
            <FormControl fullWidth margin="dense">
              <InputLabel>Town Government Playlists</InputLabel>
              <Select
                multiple
                value={additionalFields.townCouncil.playlists}
                onChange={(e) => handleDynamicFieldChange('townCouncil', 'playlists', e.target.value)}
                fullWidth
                renderValue={(selected) =>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                    {selected.map((id, index) => {
                      const playlist = townPlaylistOptions.find((p) => p.id === id) || {};
                      return <Chip key={index} label={id === "whole-channel" ? "Main Channel" : id === "live-channel" ? "Live Channel" : playlist.title} style={{
                        margin: "2px",
                        backgroundColor: "#152F8F",
                        color: "white",
                      }} />;

                    })}
                  </div>
                }
              >

                {/* Add static "Whole Channel" option */}
                <MenuItem value="whole-channel">
                  <Checkbox checked={additionalFields.townCouncil.playlists.includes('whole-channel')} />
                  <ListItemText primary="Main Channel" />
                </MenuItem>
                <MenuItem value="live-channel">
                  <Checkbox checked={additionalFields.townCouncil.playlists.includes('live-channel')} />
                  <ListItemText primary="Live Channel" />
                </MenuItem>

                {loadingTownPlaylists ? (
                  <MenuItem disabled>
                    <CircularProgress size={24} />
                    Loading Town Playlists...
                  </MenuItem>
                ) : townPlaylistOptions.map((playlist) => (
                  <MenuItem key={playlist.id} value={playlist.id}>
                    <Checkbox checked={additionalFields.townCouncil.playlists.includes(playlist.id)} />
                    <ListItemText primary={playlist.title} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>



            <TextField
              margin="dense"
              label="Town Website URL"
              fullWidth

              value={additionalFields.townCouncil.website_url}
              onChange={(e) =>
                handleDynamicFieldChange("townCouncil", "website_url", e.target.value)
              }
            />

            <TextField
              margin="dense"
              label="Town Notes"
              fullWidth
              multiline
              rows={3}
              value={additionalFields.townCouncil.notes}
              onChange={(e) =>
                handleDynamicFieldChange("townCouncil", "notes", e.target.value)
              }
            />

          </>
        )}





      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} style={{ backgroundColor: "red", color: "white" }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} style={{ backgroundColor: "#0B194A", color: "white" }} disabled={isSubmitting}>

          {isSubmitting ? "Submitting..." : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
